import { writable } from "svelte/store";

export const modalCountStore = writable(0);
